import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import payments from './payment/reducer';
import common from './common/reducer';
import devices from './device/reducer';
import merchants from './merchant/reducer';


const reducers = combineReducers({
  menu,
  settings,
  authUser,
  payments,
  common,
  devices,
  merchants
});

const initialState = reducers({}, {})

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT_USER') {
    state = initialState
  }

  return reducers(state, action)
}

export default rootReducer;
